import React from 'react';
import { motion } from 'framer-motion';
import { Video, Users, Building, ExternalLink } from 'lucide-react';
import { Card } from '../../ui/card';

const iconMap = {
  Video,
  Users,
  Building,
};

const TractionSlide = ({ data }) => {
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Metrics */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {data.metrics.map((metric, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 + index * 0.1 }}
          >
            <Card className="bg-gradient-to-br from-emerald-500/10 to-teal-500/10 border-emerald-500/30 p-5 text-center">
              <div className="text-3xl md:text-4xl font-bold text-emerald-400 mb-1">
                {metric.value}
              </div>
              <p className="text-slate-400 text-sm">{metric.label}</p>
            </Card>
          </motion.div>
        ))}
      </div>

      {/* Highlights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {data.highlights.map((highlight, index) => {
          const Icon = iconMap[highlight.icon];
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 + index * 0.1 }}
            >
              <Card className="bg-slate-800/50 border-slate-700/50 p-5 h-full">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-cyan-500/10 rounded-xl shrink-0">
                    <Icon className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-1">{highlight.title}</h3>
                    <p className="text-slate-400 text-sm">{highlight.desc}</p>
                    {highlight.link && (
                      <a 
                        href={`https://${highlight.link}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 mt-2 text-cyan-400 text-sm hover:text-cyan-300 transition-colors"
                      >
                        <ExternalLink className="w-3 h-3" />
                        {highlight.link}
                      </a>
                    )}
                  </div>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default TractionSlide;
